<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Picking Supply For Subcontract Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
				<app-input-combobox-autocomplete :options="workOrderSupplySubContractDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="Work Order Supply For Subcon Detail" id="input-" size="sm" :model.sync="model.workOrderSupplyForSubconDetailId"   :selected="model.workOrderSupplyForSubconDetail != null ? model.workOrderSupplyForSubconDetail.part : ''" @input="getWorkOrderSupplySubContractDetails" />
				<app-input-textbox id="fieldset-supply-qty" label-cols-lg="12" label="Supply Qty" label-for="input-supply-qty" size="sm" :model.sync="model.supplyQty"  />
				<app-input-textbox id="fieldset-actual-qty" label-cols-lg="12" label="Actual Qty" label-for="input-actual-qty" size="sm" :model.sync="model.actualQty"  />
					</b-col>
					<b-col cols="12" lg="6">
				<b-form-group id="fieldset-is-completed" label-cols-lg="12" label="Is Complete" label-for="input-is-completed">
						<b-form-checkbox id="input-is-completed" v-model="model.isCompleted"></b-form-checkbox>
					</b-form-group>
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Process By" id="input-" size="sm" :model.sync="model.processById"   :selected="model.processBy != null ? model.processBy.firstName : ''" @input="getUserInfos" />
				<app-input-datetimepicker id="fieldset-process-date" label-cols-lg="12" label="Process Date" size="sm" :model.sync="model.processDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />
				<app-input-textarea id="fieldset-remarks" label-cols-lg="12" label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import PickingSupplyForSubcontractDetail from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetail';
import PickingSupplyForSubcontractDetailFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailFilter';

import PickingSupplyForSubcontract from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontract';
import PickingSupplyForSubcontractFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import WorkOrderSupplySubContractDetailFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextarea,
		PopupRouterView,
		AppInputScan,
	},
	mixins : [validationMixin, focusInput],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			workOrderSupplySubContractDetails : [],
			parts : [],
			userInfos : [],
			isBusy: false,
		}
	},
	methods : {
		getPickingSupplyForSubcontractDetail : async function(id) {
			this.isBusy = true;
			PickingSupplyForSubcontractDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getWorkOrderSupplySubContractDetails : async function(input) {
			let filter = new WorkOrderSupplySubContractDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderSupplySubContractDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContractDetails = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},
		scanPart() {
			this.focusInput(this, "fieldset-part");
		},

	},	beforeMount() {
		//this.getWorkOrderSupplySubContractDetails();
		//this.getParts();
		//this.getUserInfos();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPickingSupplyForSubcontractDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getWorkOrderSupplySubContractDetails();
				this.getParts();
				this.getUserInfos();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPickingSupplyForSubcontractDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
